module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/OatmealPro2-Regular.302f56c8.woff2";